<template>
  <v-tooltip
    v-if="btn.tooltip"
    :disabled="!btn.tooltip || (typeof btn.disabled === 'function' ? btn.disabled() : btn.disabled)"
    :top="btn.tooltip && btn.tooltip.top"
    :bottom="typeof btn.tooltip === 'string' ? true : btn.tooltip.bottom"
    :left="btn.tooltip && btn.tooltip.left"
    :right="btn.tooltip && btn.tooltip.right"
    :nudge-top="btn.tooltip && btn.tooltip.nudgeTop"
    :nudge-bottom="btn.tooltip && btn.tooltip.nudgeBottom"
    :nudge-left="btn.tooltip && btn.tooltip.nudgeLeft"
    :nudge-right="btn.tooltip && btn.tooltip.nudgeRight"
  >
    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
      <v-btn
        v-bind="{ ...attrs, ...tooltipAttrs }"
        v-on="{ ...on, ...tooltipOn }"
        :disabled="typeof btn.disabled === 'function' ? btn.disabled() : btn.disabled"
        :loading="typeof btn.loading === 'function' ? btn.loading() : btn.loading"
        :to="btn.to ? btn.to : null"
        hide-details
        :text="btn.text == true"
        :icon="btn.icon === true"
        :color="btn.color || 'white'"
        :class="btn.class ? 'v-app-btn ' + btn.class : 'v-app-btn'"
        @click="btn.click ? btn.click() : null"
      >
        <v-icon v-if="btn.iconName">{{ btn.iconName }}</v-icon>
        {{ !btn.icon ? btn.name : "" }}
      </v-btn>
    </template>
    <span>{{ typeof btn.tooltip === "string" ? btn.tooltip : btn.tooltip.text }}</span>
  </v-tooltip>
  <v-btn
    v-else
    v-bind="attrs"
    v-on="on"
    :disabled="typeof btn.disabled === 'function' ? btn.disabled() : btn.disabled"
    :loading="typeof btn.loading === 'function' ? btn.loading() : btn.loading"
    :to="btn.to ? btn.to : null"
    hide-details
    :text="btn.text == true"
    :icon="btn.icon === true"
    :color="btn.color || 'white'"
    :class="btn.class ? 'v-app-btn ' + btn.class : 'v-app-btn'"
    @click="btn.click ? btn.click() : null"
  >
    <v-icon v-if="btn.iconName">{{ btn.iconName }}</v-icon>
    {{ !btn.icon ? btn.name : "" }}
  </v-btn>
</template>

<script>
export default {
  name: "appButton",
  props: {
    on: Object,
    attrs: Object,
    btn: Object
  }
};
</script>
